var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKetoBrokenHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "o9lcdl257a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M414 0v896H0V0h414z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ycop2zt4ab"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52 0c28.719 0 52 23.281 52 52s-23.281 52-52 52S0 80.719 0 52 23.281 0 52 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "octqhgzl0d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.522.006c6.782-.18 12.715 3.658 15.581 9.335l-7.022 11.456 7.512-1.476-4.276 14.723 4.703 1.358.391 14.596L7.215 30.852l.047-.03C3.024 27.842.154 23.005.006 17.42-.242 8.056 7.148.256 16.522.006z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gt24c5b2pe"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.39 9.085C5.413 3.338 11.61-.414 18.51.037c9.348.61 16.439 8.688 15.829 18.035-.364 5.575-3.415 10.299-7.768 13.112l.046.033L0 49.137 4.423 32.31.91 30.817l5.777-13.95-6.157-.915z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d5l2nnwt0c",
    x1: 0,
    y1: 104,
    x2: 104,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#264653",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A9D8F",
    offset: "43.971%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9C369",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#o9lcdl257a)",
    transform: "translate(-155 -134)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ycop2zt4ab)",
    transform: "translate(155 134)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#d5l2nnwt0c)",
    d: "M0 0h104v104H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#octqhgzl0d)",
    transform: "translate(173.76 165)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h33.411v50H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gt24c5b2pe)",
    transform: "translate(207.86 165.695)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h34.375v49.137H0V0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKetoBrokenHeart);
export default __webpack_public_path__ + "static/media/keto_broken_heart.34875da9.svg";
export { ForwardRef as ReactComponent };